define(["./microstrategyModule",], function (module) {
    return module.directive("nlgMicroStrategy", [function () {
        "use strict";

        return {
            restrict: "E",
            template: "<div id=\"LibraryHomePageContainer\" style=\"width: 100%; min-height: 85vh\"></div>",
            scope: {},
            controller: ["$scope", "loadingService", "$http", "remoteExceptionHandler", "messagesModal", "microstrategyServiceUrl", "microstrategyService", "$state", "$interval",
                function ($scope, loadingService, $http, remoteExceptionHandler, messagesModal, microstrategyServiceUrl, microstrategyService, $state, $interval) {
                    // Workaround para poder acessar com outra empresa no mesmo navegador: DLOGALP-2957
                    microstrategyService.clearCache();

                    var BASE_URL = "https://totvs.cloud.microstrategy.com/MicroStrategyLibrary/";
                    var LIBRARY_URL = BASE_URL + "app/config/" + microstrategyServiceUrl.microstrategyLibraryIdentifier + "?app.embedded=true";
                    var microstrategy = window.microstrategy;
                    var config = {
                        serverUrl: LIBRARY_URL,
                        placeholder: document.getElementById("LibraryHomePageContainer")
                    };

                    return loadingService(loginInternal()).then(function () {
                        return microstrategy.embeddingContexts.embedLibraryPage(config);
                    });

                    function loginInternal() {
                        return $http.get(microstrategyServiceUrl.loginUrl)
                            .then(function (response) {
                                return authenticate(response.data);
                            }).catch(function (e) {
                                return redirectToHomeState(e);
                            });
                    }

                    function authenticate(microstrategyAuthentication) {
                        var options = {
                            method: "POST",
                            credentials: "include",
                            mode: "cors",
                            headers: {"content-type": "application/json"},
                            body: JSON.stringify({
                                "loginMode": -1, "identityToken": microstrategyAuthentication.identityToken
                            })
                        };

                        var DELEGATE_SESSION_URL = BASE_URL + "api/auth/delegate";
                        return fetch(DELEGATE_SESSION_URL, options).then(function (response) {
                            if (!response.ok) {
                                return redirectToHomeState();
                            }
                            microstrategyService.storeMicrostrategyAuthToken(microstrategyAuthentication.authToken);
                            configureAutomaticRenewSession();
                            return response;
                        });
                    }

                    function redirectToHomeState(error) {
                        if (!error) {
                            return messagesModal("dialog.warning", ["microstrategy.erron.on.login"])
                                .then($state.go(microstrategyServiceUrl.homeState));
                        }
                        return remoteExceptionHandler()(error)
                            .then($state.go(microstrategyServiceUrl.homeState));
                    }

                    function configureAutomaticRenewSession() {
                        var renewSessionInterval = $interval(microstrategyService.renewSession, 600000);
                        $scope.$on("$destroy", function () {
                            $interval.cancel(renewSessionInterval);
                            microstrategyService.clearCache();
                        });
                    }
                }]
        };
    }]);

});